import instance from "../config";

// Administradores (candidatos): solo el superadmin.

// -> [{ id, username, correo, estado, dobleFactor, fechaCorte, createdAt, totalDigitadores, totalElectores, vencido }]
export const getAdministradores = async () => {
  const { data } = await instance.get("/administradores");
  return data;
};

// fechaCorte: "YYYY-MM-DD" (último día en que la cuenta puede usarse)
export const crearAdministrador = async ({ username, password, correo, dobleFactor, fechaCorte }) => {
  const { data } = await instance.post("/administradores", { username, password, correo, dobleFactor, fechaCorte });
  return data;
};

// username y password opcionales: si van vacíos no se cambian.
// estado y dobleFactor opcionales: si no se envían, el backend conserva el valor actual.
export const editarAdministrador = async (id, { username, password, correo, estado, dobleFactor, fechaCorte }) => {
  const { data } = await instance.put(`/administradores?id=${id}`, {
    username,
    password,
    correo,
    estado,
    dobleFactor,
    fechaCorte,
  });
  return data;
};
